/* WaveWear /pages tone v1 — alignment fix (2026-10-20, Claude 시안)
   Rule taken from the K2 study mockup: text that runs 3+ lines is left-aligned.
   Short centered text (1-2 lines: labels, headings, single sentences) is kept.
   When a paragraph inside a card is switched to left, the rest of that card
   (title, link, button row) is switched too, so one card never mixes center and left.
   A "card" = the largest block around the paragraph that still shows < 700 characters.
   GemPages loads section styles while you scroll, so the check runs again on scroll.
   GemPages buttons used as titles (28+ characters) lose the button uppercase.
   Skips the photo heroes (.ph-ct) and the K2 study body (.wwk2).
   v1f (2026-10-21): the card must look like a card (background, border or rounded corners).
   v1e (2026-10-21): runs only inside desktop cards (no lone paragraphs, nothing on phones).
   v1d (2026-10-20 night): never touches wide or edge-to-edge text (hero banners
   stay centered), and card matching runs only on desktop for cards < 60% wide. */
(function () {
  var main = document.getElementById('MainContent');
  if (!main) return;
  var SKIP = '.ph-ct, .wwk2, [data-wwp-keep]';

  function isFlex(cs) { return cs.display === 'flex' || cs.display === 'inline-flex'; }

  function lines(el, cs) {
    var lh = parseFloat(cs.lineHeight);
    if (!lh) lh = parseFloat(cs.fontSize) * 1.5;
    return Math.round(el.getBoundingClientRect().height / lh);
  }

  function toLeft(el) {
    var cs = getComputedStyle(el);
    if (cs.textAlign === 'center') el.style.setProperty('text-align', 'left', 'important');
    if (isFlex(cs)) {
      if (cs.flexDirection.indexOf('column') === 0) {
        if (cs.alignItems === 'center') el.style.setProperty('align-items', 'flex-start', 'important');
      } else if (cs.justifyContent === 'center') {
        el.style.setProperty('justify-content', 'flex-start', 'important');
      }
    }
    el.setAttribute('data-wwp-align', 'left');
  }

  function narrow(el) {
    var r = el.getBoundingClientRect(), vw = window.innerWidth;
    if (r.left < 12 || r.right > vw - 12) return false;
    if (!isPhone() && r.width > vw * 0.66) return false;
    return true;
  }

  // a visible box: own background colour, a border, or rounded corners
  function boxed(node) {
    var cs = getComputedStyle(node);
    var bg = cs.backgroundColor;
    var hasBg = bg && bg !== 'transparent' && !/rgba\(\d+, \d+, \d+, 0\)/.test(bg) && !/^rgb\(255, 255, 255\)$/.test(bg);
    return hasBg || parseFloat(cs.borderTopWidth) > 0 || parseFloat(cs.borderTopLeftRadius) > 0;
  }

  // phones: some pages overflow sideways, which makes innerWidth look wider than the screen
  function isPhone() {
    return (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) || (window.screen && screen.width < 750) || window.innerWidth < 750;
  }

  function cardOf(el) {
    if (isPhone()) return null;
    var node = el.parentElement, card = null;
    for (var i = 0; i < 7 && node && node !== main; i++) {
      // innerText = visible text only (GemPages hides style/JSON text inside blocks)
      if ((node.innerText || '').length >= 700) break;
      if (node.getBoundingClientRect().width > window.innerWidth * 0.6) break;
      card = node;
      node = node.parentElement;
    }
    // v1f: only act inside something that looks like a card on screen
    for (var c = el.parentElement; c && c !== card.parentElement; c = c.parentElement) {
      if (boxed(c)) return card;
    }
    return null;
  }

  function titleButtons() {
    var btns = main.querySelectorAll('.gp-button-base');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.getAttribute('data-wwp-title')) continue;
      if ((b.textContent || '').trim().length < 28) continue;
      b.style.setProperty('text-transform', 'none', 'important');
      b.style.setProperty('letter-spacing', '-.01em', 'important');
      b.style.setProperty('font-family', 'var(--wp-text)', 'important');
      b.style.setProperty('font-weight', '700', 'important');
      var inner = b.querySelectorAll('*');
      for (var j = 0; j < inner.length; j++) {
        inner[j].style.setProperty('text-transform', 'none', 'important');
        inner[j].style.setProperty('letter-spacing', '-.01em', 'important');
      }
      b.setAttribute('data-wwp-title', '1');
    }
  }

  function fix() {
    titleButtons();
    var texts = main.querySelectorAll('p, li, [class*="gp-text"]');
    for (var i = 0; i < texts.length; i++) {
      var el = texts[i];
      if (el.getAttribute('data-wwp-align') || el.closest(SKIP)) continue;
      if (!el.offsetParent) continue;
      var cs = getComputedStyle(el);
      if (cs.textAlign !== 'center') continue;
      if (lines(el, cs) < 3) continue;
      if (!narrow(el)) continue;
      // v1e: only inside real cards on desktop, so a heading and its paragraph never split
      var card = cardOf(el);
      if (!card) continue;
      toLeft(el);
      var parts = [card].concat(Array.prototype.slice.call(card.querySelectorAll('*')));
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        if (p.closest(SKIP)) continue;
        var pcs = getComputedStyle(p);
        if (pcs.textAlign === 'center') { toLeft(p); continue; }
        if (isFlex(pcs) && !p.querySelector('img, picture, video, svg')) toLeft(p);
      }
    }
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; fix(); }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
  window.addEventListener('load', fix);
  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('resize', soon);
  setTimeout(fix, 2500);
})();
